



































































































import Vue, { PropType } from 'vue'
import { debounce } from 'debounce'
import Media from '@/types/Media.interface'
import { MessageSendType } from '@/types/Message.interface'
import MessageDraft from '@/types/MessageDraft.interface'
import Person from '@/types/Person.interface'
import { mapGetters } from 'vuex'
import mediaMixin from '@/mixins/media-mixin'
import Template from '@/types/Template.interface'
import MessageEmojiMenu from '@/components/MessageEmojiMenu.vue'
import MessageMediaMenu from '@/components/MessageMediaMenu.vue'
import MessageTagMenu from '@/components/MessageTagMenu.vue'
import MessageTemplatesMenu from '@/components/TemplatesMenu.vue'
import ShortLinkMenu from '@/components/ShortLinkMenu.vue'
import { popPreview } from '@/utility/helpers'
import CommentTextFormTextArea from '@/components/CommentTextFormTextArea.vue'
import MessageTextFormTextArea from '@/components/MessageTextFormTextArea.vue'
import MessageCommentButton from '@/components/MessageCommentButton.vue'
import MessageMentionsButton from '@/components/MessageMentionsButton.vue'
import MessageTextFormSubmitButton from '@/components/MessageTextFormSubmitButton.vue'
export default Vue.extend({
    mixins: [mediaMixin],
    components: {
        CommentTextFormTextArea,
        MessageCommentButton,
        MessageEmojiMenu,
        MessageMediaMenu,
        MessageMentionsButton,
        MessageTagMenu,
        MessageTemplatesMenu,
        MessageTextFormSubmitButton,
        MessageTextFormTextArea,
        ShortLinkMenu
    },
    props: {
        //  Determines if the textarea is autofocued when the component is mounted
        autofocus: {
            type: Boolean,
            default: false
        },
        //  The channel context of the form (optional)
        channelId: {
            type: Number,
            default: null
        },
        //  Determines if we are posting a comment or not
        comment: {
            type: Boolean,
            default: false
        },
        //  Media set here will be inserted into the form when the component is mounted
        defaultMedia: {
            type: Object as PropType<Media>,
            default: null
        },
        //  Determines if the entire input is disabled
        disabled: {
            type: Boolean,
            default: false
        },
        //  Determines if we display a little hint on our media menu or not
        hint: {
            type: Boolean,
            default: false
        },
        //  If is invoice, show invoice tags in message-tag-menu
        isInvoice: {
            type: Boolean,
            default: false,
            required: false
        },
        //  The person we are sending this message to, can be null if not currently sending messages
        person: {
            type: Object as PropType<Person>,
            default: null
        },
        //  Determines if the 'print conversation' button is shown
        print: {
            type: Boolean,
            default: true
        },
        //  Determines the height of the textarea (in rows)
        rows: {
            type: Number,
            default: 3
        },
        //  Determines if the button says 'save' or 'send'
        save: {
            type: Boolean,
            default: false
        },
        //  Determines if the 'send' and 'schedule' buttons are visible
        send: {
            type: Boolean,
            default: false
        },
        //  Determines if our send buttons are disabled
        sendDisabled: {
            type: Boolean,
            default: false
        },
        //  Determines if the comments button is shown
        showCommentsBtn: {
            type: Boolean,
            default: false
        },
        //  Determines if the emoji menu is shown
        showEmojisMenu: {
            type: Boolean,
            default: true
        },
        //  Determines if the links menu is shown
        showLinksMenu: {
            type: Boolean,
            default: true
        },
        //  Determines if the media menu is shown
        showMediaMenu: {
            type: Boolean,
            default: true
        },
        //  Determines if the tags menu is shown
        showTagsMenu: {
            type: Boolean,
            default: true
        },
        //  Determines if the template menu is shown
        showTemplatesMenu: {
            type: Boolean,
            default: true
        },
        //  An override for the max length of our message form
        textLimit: {
            type: Number,
            default: null
        },
        // Determines if we want to track if a user is typing (only use for channels)
        trackTyping: {
            type: Boolean,
            default: false
        },
        //  Text set here is inserted into the text v-model when mounted
        insert: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            //  Store default message properties (for calculating character length)
            messageConfig: {
                messagePartLimit: 20,
                defaultSMSLength: 160,
                multipartSMSHeaderLength: 7,
                unicodeSMSLength: 70
            },
            //  Determines if there is an MMS attached
            media: null,
            //  Determines if we pop the character limit dialog
            //popLimit: true,
            //  Determines if we are sending a message w/o message preview
            sending: false,
            //  The text we're assembling with the component
            text: '',
            //prev: '',
            //  Determines if we are uploading media or not
            uploading: false
        }
    },
    mounted() {
        // If possible, set our media
        this.defaultMedia && (this.media = this.defaultMedia)

        //  Wait for dom to finish loading (so we can focus on the textarea)
        this.$nextTick(() => {
            //  If 'insert' text exists, insert it!
            if (this.insert) {
                this.text = this.insert

                // Tell the parent we have inputted text
                //this.$emit('input', this.text)
            }
        })
    },
    computed: {
        ...mapGetters([
            'isApp',
            'plan',
            'smsAccount',
            'stripeCustomerHasPayment',
            'subscription',
            'tenant',
            'trialing',
            'userTyping'
        ]),
        //  Determine if the tenant's message provider is Bandwidth (ie MMS is available)
        bandwidthProvider(): boolean {
            //  If we don't have an Sms Account, return true
            if (!this.smsAccount) return true

            //  Else, if they do, only return true if sms account is bandwidth
            return this.smsAccount.provider === 'bandwidth'
        },
        //  Determine the credit cost to send the message
        creditCount(): number {
            //  If the message count is greater than 3, we return default 3
            if (this.messageCount > 3) return 3

            //  Else, if the message contains media (ie is MMS), we return default 3
            if (this.media) return 3

            //  Else, return the message count (will be less than 3)
            return this.messageCount
        },
        //  Determine if the tenant's subscription tier disables MMS
        disableMMS(): boolean {
            //  If no plan, return true
            if (!this.plan) return true

            //  Else, check if we are trialing
            if (this.subscription.status === 'trialing') return true

            //  Else return false
            return false
        },
        //  Determine if the send button is enabled
        disableSubmit(): boolean {
            //  If the sendDisable prop override is set, use it
            if (this.sendDisabled) return this.sendDisabled

            //  Else, if media is loaded, button is enabled
            if (this.media) return false

            //  Else, if text does NOT exist, button is disabled
            if (this.text.length === 0) return true

            //  Else, if we are uploading media, button is disabled
            if (this.uploading === true) return true

            //  No other circumstances? return default false
            return false
        },
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        //  The max allowed characters for message text
        maxLength() {
            //  If the override was provided, use it instead
            if (this.textLimit) return this.textLimit

            //  Calculate the standard max character limit
            const max = this.messageCharLimit * this.messageConfig.messagePartLimit

            //  Return our max
            return max
        },
        //  Determine the number of message parts to send the current text
        messageCount(): number {
            //  Calculate how many messages to send the text
            let count = Math.ceil(this.text.length / this.messageCharLimit)

            //  If the count is greater than zero, return the count
            if (count > 0) return count

            //  Else, return the default 1 (even if no text exists)
            return 1
        },
        //  Determine the character limit for a single message part
        messageCharLimit(): number {
            //  If message text does NOT exist, return default 160 limit
            if (this.text.length === 0) return 160

            //  Else, set default configuration
            let config = this.messageConfig
            let smsHeaderLength = config.multipartSMSHeaderLength
            let smsPartLength = config.defaultSMSLength

            // Check if the text contains unicode (which will force unicode)
            let hasUnicode = /[^\u0000-\u00ff]/.test(this.text)

            // If the message has unicode the parts will be a different length, so adjust them
            if (hasUnicode) {
                smsPartLength = config.unicodeSMSLength
                smsHeaderLength = Math.floor(config.multipartSMSHeaderLength * 0.5)
            }

            //  Check if the text will be a multipart message
            let isMultipart = this.text.length > smsPartLength

            //  Determine the character limit (multipart requires we subtract the header length)
            const limit = isMultipart ? smsPartLength - smsHeaderLength : smsPartLength

            //  Return the character limit
            return limit
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        //  Determine if the message will be sent as an MMS
        showMMS(): boolean {
            //  If the SmsAccount has not been loaded yet, return false (this occurs when switching between tenants)
            if (!this.$store.getters.smsAccount) return false

            //  Check if tenant has a message provider that offers MMS
            const mmsAvailable = this.$store.getters.smsAccount.provider === 'bandwidth'

            //  Determine if the message will be sent as an MMS (ie its available AND the message count if greater than 3)
            const showMMS = mmsAvailable && this.messageCount > 3

            // Return the result
            return showMMS
        },
        //  The VeeValidate validation string for the textarea input
        textValidation() {
            //  If media does NOT exist, than text is a required field
            if (!this.media) return `required|message_length:${this.totalCharLimit}`

            //  Else, return only character limit validation
            return `message_length:${this.totalCharLimit}`
        },
        //  Determine the max character limit for a multipart message
        totalCharLimit(): number {
            //  Calculate our maximum chars
            let currentCharLimit = this.messageCharLimit * this.messageCount
            let maximumChars = this.messageCharLimit * this.messageConfig.messagePartLimit

            // Allows the limit to expand dynamically but not exceed max
            return Math.min(currentCharLimit, maximumChars)
        }
    },
    methods: {
        //  Focus on the textarea input
        autoFocus(start: boolean, hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            //  Fetch the textarea input
            const dom = document.getElementById('message-text-box') as HTMLInputElement

            //  If comment is true, then tell our ref to placeCursor instead
            if (this.comment) return this.$refs.messageTextForm.placeCursor(dom)

            //  If start is true, then set our selection range to the beginning
            if (start) dom.setSelectionRange(0, 0)

            // Get which element has focus currently from the app page
            const active = document.activeElement

            // If our hotKeysEnabled setting is true, we let the hotkey get used
            if (dom !== active) {
                //  Focus on the textarea input
                dom.focus()
            }
        },
        //  Determine if the tenant is able to send a message (ie has payment, credits, etc.)
        canTenantSend(type: MessageSendType): boolean {
            //  If this is a comment, let it pass
            if (type === 'comment') return true

            //  If no plan, return false
            if (!this.plan) return false

            //  Else, check if we are trialing
            const trialing = this.subscription.status === 'trialing'

            //  Grab the credits this user has
            const credits = this.tenant.credits

            //  If the message costs more than the number of credits we have AND we are on start plan, return false
            if (credits < this.messageCount && trialing) return false

            //  If the tenant is about to use more than 50 of their 500 credits and they are trialing and they don't have a payment card on file
            //  Give them the option to enter their payment card for the other 450 credits
            if (trialing && !this.stripeCustomerHasPayment) {
                return false
            }

            return true
        },
        createPastedFile(file: File): File {
            const extension = file.type.split('/')[1] || 'png'
            const random = Math.random().toString(36).slice(2, 10)
            const timestamp = Date.now()
            const name =
                `pasted-image-${timestamp}-${random}.${extension}`

            return new File([file], name, {
                lastModified: timestamp,
                type: file.type
            })
        },
        //  Overwrite current text with a message draft
        insertDraft(draft: MessageDraft): void {
            //  Set the current text to the draft text
            this.text = draft.text
        },
        //  Insert a media image into the textarea input (null input removes image from textarea)
        insertMedia(file: Media | null): void {
            //  Append the link to this
            this.media = file
        },
        //  Concatenate an http link to the end of the current text
        insertLink(link: string): void {
            //  Check if the text ends with a space
            const hasSpace = this.text[this.text.length - 1] === ' '

            //  If the text does NOT end with a space, add one so tag doesn't merge with last word
            if (!hasSpace) this.text += ' '

            //  Insert text
            this.text += link

            //  Emit input event (since text has changed outside the @input event)
            this.$emit('input', this.text)
        },
        insertMention(): void {
            //  Tell the parent to update
            this.$refs.messageTextForm.insertMention()
        },
        //  Overwrite the current text with a message template
        insertTemplate(template: Template): void {
            //  If there is media attached, insert media
            if (template.media) this.insertMedia(template.media)

            //  If the template has a message body...
            if (template.message_body) {
                //  Overwrite the current text with with our template text
                this.text = template.message_body

                //  Emit input event (since text has changed outside the @input event)
                this.$emit('input', this.text)

                //  On the next tick lets calculate our input height
                this.$nextTick(() => this.$refs.messageTextForm.calculateHeight())
            }
        },
        insertTextBuffer(text: string): void {
            //  If comments are disabled, use our own handler
            if (!this.comment) this.insertText(text)
            //  Else, comments are enabled, then tell our comment area to insert text
            else this.$refs.messageTextForm.appendText(text, true)
        },
        //  Insert text at the current cursor position
        insertText(text: string): void {
            //  Get position of cursor
            let cursorPos =
                this.$refs.messageTextForm.$refs.cursorPos.$refs.input.selectionStart

            //  Get part of message before cursor
            let firstPart = this.text.slice(0, cursorPos)
            let secondPart = this.text.slice(cursorPos)

            //  Check if the first part ends with a space
            const hasSpace = firstPart[firstPart.length - 1] === ' '

            //  If the text does NOT end with a space, add one so tag doesn't merge with last word
            if (!hasSpace) firstPart += ' '

            //  Assemble the new message text
            const newText = `${firstPart}${text}${secondPart}`

            //  Set message text to constructed message
            this.text = newText

            //  Emit input event (since text has changed outside the @input event)
            this.$emit('input', this.text)

            //  Autofocus our input
            this.autoFocus()
        },
        // Debounce prevents double/triple sending of same message if user presses enter twice
        keyboardSubmit: debounce(function (text: string) {
            //  Remove our unicode with non-unicode
            this.replaceUnicode(text)

            //  If comment mode is enabled, then we do submit comment
            if (this.comment) this.submit('comment')
            //  Call our submit send
            else this.submit('send')
        }, 200),
        //  Handler for when the textarea loses focus
        onBlur() {
            //  Remove the typing indicator
            this.setTypingIndicator(false)

            //  Replace our unicode
            this.replaceUnicode(this.text)
        },
        //  Handler for when the textarea is focused on
        onFocus() {
            //  Show the typing indicator
            this.setTypingIndicator(true)
        },
        //  Handler for textarea input
        onInput(val: string): void {
            //  Update the value bound to our textarea
            this.text = val

            // Tell the parent we have inputted text
            this.$emit('input', val)
        },
        //  Insert 'drag-n-dropped' image into the textarea input
        async onMediaDrop(event): Promise<void> {
            //  Get the image from the drop event
            const img = await this.onDrop(event)

            //  Insert the image into the textarea
            this.insertMedia(img)
        },
        async onPaste(event: ClipboardEvent): Promise<void> {
            if (this.comment || this.disabled || !event.clipboardData) return

            const items = event.clipboardData.items
            let image: File | null = null

            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== 0) continue

                image = items[i].getAsFile()
                break
            }

            if (!image) return

            event.preventDefault()
            this.uploading = true

            try {
                const file = this.createPastedFile(image)
                const media = await this.filesChange([file])

                this.insertMedia(media)
            } finally {
                this.uploading = false
            }
        },
        //  Handler for Media Menu uploading event
        onUpload(bool: boolean) {
            //  Update the image uploading tracker
            this.uploading = bool
        },
        // Tests if a message passes the character limit
        passesMessageCharacterLimit(message: string): boolean {
            //  Determine if the message under the character limit (ie it passes)
            const pass =
                message.length <
                this.messageCharLimit * this.messageConfig.messagePartLimit

            //  Return the result
            return pass
        },
        //  Pop the character limit error dialog
        popCharacterLimitError(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Character Limits',
                icon: 'mdi-comment-text-outline',
                color: 'primary',
                text: `Message character limit reached.`
            })
        },
        //  Pop the credit limit dialog
        popCreditLimit(): void {
            //  Get the current plan
            const plan = this.plan

            //  Grab the index from the metadata
            // const index = plan.metadata.index
            const index = 1

            //  If the tenant is trialing and does NOT have a payment card, then let them enter mobilephone to get the rest
            this.$store.dispatch('dialogOpen', {
                type: this.isApp ? 'MESSAGE' : 'CONFIRM',
                title: 'Credit Limit Reached',
                icon: 'mdi-alert',
                color: 'primary',
                text: "You've used all of your free credits included with your trial.<br>Start your paid subscription or choose a different subscription option to continue sending messages",
                hideNo: true,
                yesText: this.isApp ? null : 'Manage Plan',
                closeable: true,
                closeOnSubmit: true,
                callback: (response: boolean): void => {
                    //  If the user answered 'No' in the dialog OR this is a mobile device, do nothing
                    if (!response || this.isApp) return

                    //  Navigate the current subscrpition plan
                    this.$router.push(`/billing/manage?index=${index}`)

                    //  Close the dialogs
                    this.$store.dispatch('dialogClose', 'APP')
                }
            })
        },
        popPreview(media: Media): void {
            popPreview(media)
        },
        replaceUnicode(txt: string): void {
            //  Our replace function
            const replacement = (char: string) => {
                //  Find which character we should replace our unicode with
                return {
                    //  Replaces single quotes
                    '\u2018': "'",
                    '\u2019': "'",
                    //  Replaces double quotes
                    '\u201C': '"',
                    '\u201D': '"'
                }[char]
            }

            //  Replace the fancy unicode quotes with regular ones
            const replaced = txt.replace(/[\u2018\u2019\u201C\u201D]/g, (char: string) =>
                replacement(char)
            )

            //  Replace our text
            this.text = replaced

            // Tell the parent we have inputted text
            this.$emit('input', replaced)
        },
        //  Reset the form to its default state
        reset(): void {
            this.text = ''
            this.media = null
            this.$validator.reset()

            //  Let Inbox.vue know that the message has been sent and component reset so we need to re-add the message signature if the setting is enabled
            this.$emit('signautureAdd')

            // Tell the parent we have inputted text
            this.$emit('input', this.text)

            //  If this is a comment, then update the text of the div
            if (this.comment) this.$refs.messageTextForm.updateText(this.text, false)

            //  Tell our message text form to resize (we use this because it has debounce)
            this.$refs.messageTextForm.onInput(this.text)
        },
        //  Set the typing indicator state in the store
        setTypingIndicator(option: boolean) {
            //  If we are NOT tracking typing, do nothing
            if (!this.trackTyping) return

            //  Else, set the user typing indicator
            this.$store.commit('userTypingSet', option)
        },
        //  Emit the 'submit' event to the parent component (passing message type)
        async submit(type: MessageSendType): Promise<void> {
            //  Validate the form through our child messageTextForm
            const valid = await this.$refs.messageTextForm.validate(this.text)

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  If the tenant can NOT send, pop credit limit dialog
            // if (!this.canTenantSend(type)) return this.popCreditLimit()

            //  Else, assemble the new message
            const message = {
                channel_id: this.channelId,
                outbound: true,
                text: this.text,
                media_id: this.media?.id || null,
                media: this.media || null,
                type: type
            }

            //  Else, emit the message to the parent
            this.$emit('submit', message)
        }
    },
    watch: {
        channelId(_id: number): void {
            this.$nextTick(() => {
                if (this.autofocus && !this.isApp) this.autoFocus(true)

                //  Grab our message text form input
                const input = this.$refs.messageTextForm

                //  If it exists, then calculate the height
                if (input) input.calculateHeight()
            })
        },
        comment(): void {
            //  Autofocus our input
            this.$nextTick(() => {
                if (this.autoFocus) this.autoFocus(true)
            })
        },
        media(val: Media): void {
            //  Also emit 'uploaded' event
            this.$emit('mediaAdded', val)

            // Emit media updated
            //this.$emit('media:change', file)
        },
        text() {
            //  Check if the text passes the character limit
            const pass = this.passesMessageCharacterLimit(this.text)

            //  If the text does NOT pass, pop the character limit error
            if (!pass) this.popCharacterLimitError()

            //  Resize
            this.$nextTick(() => {
                //  Grab our message text form input
                const input = this.$refs.messageTextForm

                //  If it exists, then calculate the height
                if (input) input.calculateHeight()
            })
        }
    }
})
